module.exports = __webpack_public_path__ + "static/media/ic_check_green.98b564ab.svg";